import React from "react";
import { Switch, Route } from "react-router-dom";
import Glasses from "./Glasses";

export default function Glassesview() {
  return (
    <div>
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/glasses"
            render={(props) => <Glasses {...props} />}
          />
        </Switch>
      </React.Fragment>
    </div>
  );
}

